export default __webpack_public_path__ + "static/bg-3dcb9cd95d297353165c30db6b2cc5f5.png";